var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (this.$route.params.baseName === 'createconvar')?_c('neo-convar-details',{key:'convar-' + _vm.$route.path}):_c('neo-function-details',{key:'function-' + _vm.$route.path})
}
var staticRenderFns = []

export { render, staticRenderFns }